import React from "react";
import MiRut from "./Rut";

function PersonalInfo({ formData, setFormData }) {
  const handleSelectChange = (event) => {
   
    const name = event.target.name;
    const value = event.target.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <div className="personal-info-container">
      <div>
        <label htmlFor="nombrePropietario" className="form-label">
          Nombres Propietario
        </label>
        <input
          type="text"
          placeholder="Nombres Propietario"
          value={formData.nombrePropietario}
          onChange={(e) =>
            setFormData({ ...formData, nombrePropietario: e.target.value })
          }
          style={{ textTransform: "capitalize" }}
          required
        />
      </div>

      <div>
        <label htmlFor="apellidosPropietario" className="form-label">
          Apellidos Propietario
        </label>
        <input
          type="text"
          placeholder="Apellidos Propietario"
          value={formData.apellidoPropietario}
          onChange={(e) =>
            setFormData({ ...formData, apellidoPropietario: e.target.value })
          }
          style={{ textTransform: "capitalize" }}
          required
        />
        <div>
          <MiRut
            formData={formData}
            setFormData={setFormData}
            value={formData.rut}
            onChange={(e) => setFormData({ ...formData, rut: e.target.value })}
          />
        </div>
      </div>

      <div>
        <label htmlFor="direccionPropietario" className="form-label">
          Direccion Propietario
        </label>
        <input
          type="text"
          placeholder="Dirección Instalación"
          value={formData.direccionPropietario}
          onChange={(e) =>
            setFormData({ ...formData, direccionPropietario: e.target.value })
          }
          style={{ textTransform: "capitalize" }}
          required
        />
      </div>

      <div>
        <label htmlFor="comunaPropietario" className="form-label">
          Comuna Propietario
        </label>

        <input
          type="text"
          placeholder="Comuna Instalación"
          value={formData.comunaPropietario}
          onChange={(e) =>
            setFormData({ ...formData, comunaPropietario: e.target.value })
          }
          style={{ textTransform: "capitalize" }}
          required
        />
      </div>

      <div>
        <label htmlFor="comunaPropietario" className="form-label">
          Región Propietario
        </label>

        <select
          value={formData.regionInstalacion}
          onChange={handleSelectChange}
          //className="form-select"
          id="regionInstalacion"
          name="regionInstalacion"
          required
        >
          <option value={null}>Seleccione</option>
          <option value="Región de Arica y Parinacota">
            Región de Arica y Parinacota
          </option>
          <option value="Región de Tarapacá">Región de Tarapacá</option>
          <option value="Región de Antofagasta">Región de Antofagasta</option>
          <option value="Región de Atacama">Región de Atacama</option>
          <option value="Región de Coquimbo">Región de Coquimbo</option>
          <option value="Región de Valparaíso">Región de Valparaíso</option>
          <option value="Región Metropolitana">Región Metropolitana</option>
          <option value="Región de O'Higgins">Región de O'Higgins</option>
          <option value="Región del Maule">Región del Maule</option>
          <option value="Región de Ñuble">Región de Ñuble</option>
          <option value="Región del Biobío">Región del Biobío</option>
          <option value="Región de Los Ríos">Región de Los Ríos</option>
          <option value="Región de Los Lagos">Región de Los Lagos</option>
          <option value="Región de Aysén">Región de Aysén</option>
          <option value="Región de Magallanes">Región de Magallanes</option>
        </select>
      </div>

      <div>
        <label htmlFor="comunaPropietario" className="form-label">
          Coordenadas Instalación
        </label>
        <input
          type="text"
          placeholder="Coordenadas instalación"
          value={formData.coordenadas}
          onChange={(e) =>
            setFormData({ ...formData, coordenadas: e.target.value })
          }
          required
        />
      </div>
    </div>
  );
}

export default PersonalInfo;
